import HeadingArrowWrapper from '@components/ui/heading-arrow-wrapper';
import MarkdownWrapper from '@components/ui/markdown-wrapper';
import { TypographyVariant } from '@global/types/common';
import { Grid, Typography } from '@mui/material';
import { configTnC } from './config-tnc';

export default function TnC() {
  return (
    <HeadingArrowWrapper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'nowrap',
        height: '100%',
        padding: '0 1em',
        margin: 'auto'
      }}
      title={'Terms and Conditions'}>
      {' '}
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{
          margin: '1em 0',
          padding: '0 2em'
        }}>
        <Typography variant="body1" sx={{}}>
          Last edited on 19th February 2024
        </Typography>

        {configTnC?.map((x) => (
          <Typography variant={(x?.type as TypographyVariant) ?? 'body1'} sx={{}}>
            <MarkdownWrapper>{x.text}</MarkdownWrapper>{' '}
          </Typography>
        ))}
      </Grid>
    </HeadingArrowWrapper>
  );
}
